<i18n src="../../locales/lang.json"></i18n>

<template>

  <div class="container-fluid p-0">
    <div class="card shadow-0 border-0">
      <div class="card-body">
        <div class="row">
          <div class="col mb-2">
            {{$store.translate('procedure_permissions')}}
          </div>
        </div>        
        <div class="row">
          <div class="col-12">
            <form class="login-formx form-validate" action="index.html" onsubmit="return false" id="createLocationForm">              
              <div class="row form-group">
                <div class="col-lg-12">
                  <table>
                    <thead>
                      <tr>
                        <th style="font-weight:normal;">
                          {{$t('workspace')}}
                        </th>
                        <th style="width:100px; font-weight:normal;">
                          {{$t('readpermission')}}
                        </th>

                        <th style="width:100px; font-weight:normal;">
                          {{$t('writepermission')}}
                        </th>
                        <th style="width:100px; font-weight:normal;">
                          {{$t('executepermission')}}
                        </th>
                      </tr>
                    </thead>
                    <tr v-for="site in model">
                      <td width="70%">
                        {{site.SiteName}}
                      </td>
                      <td width="10%" v-for="type in site.PermissionsType" align="center">
                        <input type="checkbox" v-bind:id="type" v-bind:value="type" v-model="site.Permissions">
                      </td>
                    </tr>
                  </table>

                  <!--
  <div v-for="site in model" class="col-lg-12">

    <div v-for="type in site.PermissionsType">
      <input type="checkbox" v-bind:id="type" v-bind:value="type" v-model="site.Permissions">
      <label v-bind:for="type">{{type}}</label>
    </div>
  </div>
    -->
                </div>
              </div>              
              <div class="form-group row">
                <div class="col-lg-12">
                  <button @click="saveSchedulePermission" type="submit" class="btn skin primary-button pull-right"><i class="icon-cog5 mr-2"></i> {{$t('save')}}</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  
  export default {
    name: "site-permission",
    components: {
      
    },
    props: {
      procedureid: {
        required: false,
        type: Number,
        default: -1
      },
    },
    data() {
      return {
        message: "",
        model: null,
      };
    },
    methods: {
      getId() {
        return this._uid;
      },
      getProcedureShare() {
        try {
          var url = '/api/Procedure/GetSchedulePermission?procedureId=' + this.procedureid;          
          this.$http.get(url).then(async response => {
            this.model = response.data;
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      async saveSchedulePermission() {
        if (this.model===null)
          return false;        
        var request = {
          procedureId: this.procedureid, model: this.model
        };
        try {
          var response = await this.$http.post(
            '/api/Procedure/SaveSchedulePermission',
            request
          ).then(async response => {
            vm.$root.$emit('procedure_editor_can_close');
          });

        } catch (err) {
          //alert(err);
        }
      },
    },
    watch: {
      procedureid: function (newVal, oldVal) {
        this.getProcedureShare();        
      },
    },
    mounted() {     
    }
  };
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/procedure/site-permission.vue